<article class="card" [attr.is_active]="isActive" (click)="onItemClick()">
  <div class="card-body d-flex flex-row p-2">
    <div class="w-100 text-break">
      <h3 [attr.data-test-id]="'result-social-title-' + index">
        {{ data.title }}
        <h5 [attr.data-test-id]="'card-status-badge_' + index" class="text-muted">{{ getStatusMark | translate }}</h5>
      </h3>

      <h6 *ngIf="data?.specialization?.length" [attr.data-test-id]="'result-social-specialization-' + index">
        {{ data.specialization | formatCategories }}
      </h6>
      <h6
        class="mb-0"
        [attr.data-test-id]="'result-social-location-' + index"
        [innerHtml]="data.displayedLocation"
      ></h6>
    </div>
    <div class="align-self-center ms-2">
      <a
        class="btn btn-primary"
        [attr.data-test-id]="'result-social-visit-button-' + index"
        [routerLink]="data.routerLink"
        target="_blank"
      >
        {{ 'BTN_VISIT' | translate }}
      </a>
    </div>
  </div>
</article>
